import Tooltip from '@srm/ui/tooltip';
import clsx from 'clsx';
import { HiBookmark, HiOutlineBookmark } from 'react-icons/hi2';

interface IGridStateButtonProps {
    stateName?: string;
    opened: boolean;
    onClick: () => void;
}

export default function GridStateButton({ stateName, opened, onClick }: IGridStateButtonProps) {
    const label = stateName ? `Состояния таблицы. На основе «${stateName}»` : 'Состояния таблицы';
    const Icon = stateName ? HiBookmark : HiOutlineBookmark;

    return (
        <Tooltip
            background="black"
            position="bottom"
            openDelay={300}
            maxWidth="min(360px, calc(100vw - 32px))"
            label={label}
        >
            <button
                type="button"
                className={clsx('dtb__icon-btn', stateName && 'is-active')}
                aria-label={label}
                aria-haspopup="dialog"
                aria-expanded={opened}
                onClick={onClick}
            >
                <Icon aria-hidden />
            </button>
        </Tooltip>
    );
}
